/**
 * @file index.tsx
 *
 * @fileoverview Renders the list of job filters, each one is a filter as a select with a popover.
 */

import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { LayoutContext, LayoutContextInterface } from '~/jobiqo/context/layout';
import { Facet } from '~/jobiqo/models/search';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { HideDesktop } from '~/vcl/atoms/06-layout/02-visibility/01-hide-desktop';
import { HideMobile } from '~/vcl/atoms/06-layout/02-visibility/02-hide-mobile';
import { Spacing } from '~/vcl/atoms/06-layout/07-spacing';
import { FiltersIcon } from '~/vcl/icons/Filters';
import MobileFilters from './mobile';
import DesktopFilters from './desktop';

interface FacetFiltersProps {
  querystring: any;
  pathname: string;
  facets: Facet[];
  onFacetToggle: (
    name: string,
    selectedItems: string[],
    alias?: string,
  ) => void;
  getFacetSelectedItems(facet: Facet): string[];
  renderAdditionalTabs?: () => React.ReactNode;
  renderAdditionalTabPanels?: () => React.ReactNode;
  renderAdditionalFilters?: () => React.ReactNode;
}

/**
 * Toggles the navbar.
 */
export const toggleNav = (navOpened, setNavOpened) => {
  setNavOpened(!navOpened);
};

export const FacetFilters = ({
  facets,
  querystring,
  pathname,
  onFacetToggle,
  getFacetSelectedItems,
  renderAdditionalTabs,
  renderAdditionalTabPanels,
  renderAdditionalFilters,
}: FacetFiltersProps) => {
  const {
    setMobileSearchFiltersOpened,
    mobileSearchFiltersOpened,
  }: LayoutContextInterface = useContext(LayoutContext);

  return (
    <>
      <HideDesktop>
        {mobileSearchFiltersOpened && (
          <>
            <MobileFilters
              navOpened={mobileSearchFiltersOpened}
              setNavOpened={setMobileSearchFiltersOpened}
              toggleNav={() =>
                toggleNav(
                  mobileSearchFiltersOpened,
                  setMobileSearchFiltersOpened,
                )
              }
              pathname={pathname}
              querystring={querystring}
              facets={facets}
              onFacetToggle={onFacetToggle}
              getFacetSelectedItems={getFacetSelectedItems}
              renderAdditionalTabs={renderAdditionalTabs}
              renderAdditionalTabPanels={renderAdditionalTabPanels}
            />
          </>
        )}
      </HideDesktop>
      <Spacing size="medium" />
      {facets.length > 0 && (
        <HideDesktop>
          <Button
            buttonStyle="primary"
            iconed={true}
            bordered={true}
            block={true}
            onClick={(e) =>
              toggleNav(mobileSearchFiltersOpened, setMobileSearchFiltersOpened)
            }
          >
            <FiltersIcon height="20" width="20" title="Open Filters" />
            <span>
              <FormattedMessage
                id="toggle_filters"
                defaultMessage="Toggle filters"
              />
            </span>
          </Button>
        </HideDesktop>
      )}
      <HideMobile>
        <DesktopFilters
          pathname={pathname}
          querystring={querystring}
          facets={facets}
          onFacetToggle={onFacetToggle}
          getFacetSelectedItems={getFacetSelectedItems}
          renderAdditionalFilters={renderAdditionalFilters}
        />
      </HideMobile>
    </>
  );
};
export default FacetFilters;
